import React, { useState, useEffect } from 'react';
import SumsubWebSdk from '@sumsub/websdk-react';
import { useTranslation } from 'react-i18next';

const KYCSumSubSdk = ({ verificationLevel, kycConfig, validateUserRegistration }) => {
  const [accessToken, setAccessToken] = useState({});

  const { i18n } = useTranslation();
  const sumSubLanguage = i18n.language;

  const sumSubPayload = {
    clientInfo: {
      validator: kycConfig.type.toLowerCase(),
      validationStage: verificationLevel + 1,
    },
    userInfo: {},
    additionalValidationData: [],
    requestIdentifier: crypto.randomUUID(),
  };

  const onSumSubShowIFrame = async () => {
    const response = await validateUserRegistration(sumSubPayload);
    if (response) {
      setAccessToken({
        userId: response.ProcessorData.userId,
        token: response.ProcessorData.accessToken,
      });
    }
  };

  const getAccessToken = async () => {
    const response = await validateUserRegistration(sumSubPayload);
    if (response) {
      const newToken = response.ProcessorData.accessToken;
      setAccessToken({
        userId: response.ProcessorData.userId,
        token: newToken,
      });
      return newToken;
    }
  };

  useEffect(() => {
    if ((verificationLevel || verificationLevel === 0) && kycConfig) onSumSubShowIFrame();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verificationLevel, kycConfig?.type]);

  const config = {
    uiConf: {
      lang: sumSubLanguage || 'en',
    },
  };

  if (accessToken.token != null) {
    return (
      <SumsubWebSdk
        expirationHandler={getAccessToken}
        updateAccessToken={getAccessToken}
        accessToken={accessToken.token}
        config={config}
      />
    );
  } else return null;
};

export default KYCSumSubSdk;
